import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import moment from 'moment';
import { Fragment } from 'react';
import { propArrayShape, propNumber, } from '../../../../helpers/custom-prop-types';
import SplitText from '../../../Ui/Common/SplitText';
const Careers = (props) => {
    const { careers, maxCount, minCount } = props;
    return (_jsx("dl", Object.assign({ className: 'experiences is-free' }, { children: careers.map((career, index) => {
            if (minCount !== undefined && minCount > index) {
                return null;
            }
            if (maxCount !== undefined && maxCount <= index) {
                return null;
            }
            const momentDate = moment(career.date);
            return (_jsxs(Fragment, { children: [_jsx("dd", { children: `${momentDate.year()}/${`0${(momentDate.month() + 1).toString()}`.slice(-2)}` }), _jsxs("dt", { children: [_jsx("h3", { children: career.title +
                                    (career.position ? `（${career.position}）` : '') }), _jsx(SplitText, { text: career.content, wrap: 'p' })] })] }, career.id));
        }) })));
};
Careers.propTypes = {
    careers: propArrayShape().isRequired,
    maxCount: propNumber(),
    minCount: propNumber(),
};
Careers.defaultProps = {
    maxCount: undefined,
    minCount: undefined,
};
export default Careers;
